// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"243":"848d72d9","865":"00c1a019"}[chunkId] + ".css";
};